import { render, staticRenderFns } from "./cameraGuide.vue?vue&type=template&id=13cbb06d&scoped=true&"
import script from "./cameraGuide.vue?vue&type=script&lang=ts&"
export * from "./cameraGuide.vue?vue&type=script&lang=ts&"
import style0 from "./cameraGuide.scss?vue&type=style&index=0&id=13cbb06d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cbb06d",
  null
  
)

export default component.exports